var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCountryFlagSpainsvgrIcon = function SvgCountryFlagSpainsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#country-flag-spain_svgrIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M0 26.208C0 29.407 1.073 32 2.397 32h27.206C30.927 32 32 29.407 32 26.208v-4.875H0zM29.603 0H2.397C1.073 0 0 2.593 0 5.792v4.875h32V5.792C32 2.592 30.927 0 29.603 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD250",
    d: "M32 9.824H0v12.35h32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "m13.518 16 .467-2.142a.314.314 0 0 0-.303-.384h-.33a.315.315 0 0 0-.302.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M14.069 14.876h-1.104v4.772h1.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M14.345 14.315H12.69v.562h1.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M14.345 16h-2.76v.561h2.76zM14.345 18.246l-1.655-.561v-.562l1.655.561zM5.24 16l.469-2.142a.314.314 0 0 0-.303-.384h-.33a.315.315 0 0 0-.303.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M7.172 14.315a.557.557 0 0 0-.552.562v3.649c0 .682.626 1.965 2.76 1.965 2.132 0 2.758-1.283 2.758-1.965v-3.65a.557.557 0 0 0-.552-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M9.38 17.122H6.62v-2.245c0-.31.247-.562.552-.562H9.38zM9.378 17.123h2.759v1.403c0 .776-.618 1.404-1.38 1.404s-1.379-.628-1.379-1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M6.62 17.122h2.76v1.404c0 .775-.618 1.403-1.38 1.403s-1.38-.628-1.38-1.403z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M8.828 19.642v-2.52h-.552v2.779c.205-.043.39-.135.552-.259M7.724 19.902v-2.779h-.551v2.52c.16.124.346.216.551.259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M8.828 15.999H7.173v.561h1.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M8.828 14.876H7.173v.561h1.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M8.551 15.209H7.448v1.017H8.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M5.793 14.876H4.689v4.772h1.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M6.069 19.367H4.413v.562H6.07zM6.07 14.315H4.414v.562H6.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M6.345 19.93H4.138v.561h2.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M14.62 19.37h-1.654v.56h1.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M14.62 19.93h-2.207v.561h2.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M11.035 13.755h-3.31v.561h3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB441",
    d: "M9.655 12.07h-.551v1.685h.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M8.827 12.913A.836.836 0 0 1 8 12.07c0-.465.371-.842.827-.842.457 0 .828.377.828.842a.836.836 0 0 1-.828.842m0-1.123a.28.28 0 0 0-.275.28c0 .155.123.281.275.281a.28.28 0 0 0 .276-.28.28.28 0 0 0-.276-.281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M9.931 12.913a.836.836 0 0 1-.827-.842c0-.465.371-.842.827-.842.457 0 .828.377.828.842a.836.836 0 0 1-.828.842m0-1.123a.28.28 0 0 0-.276.28c0 .155.124.281.276.281a.28.28 0 0 0 .276-.28.28.28 0 0 0-.276-.281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M11.035 13.474a.836.836 0 0 1-.828-.842c0-.464.371-.842.828-.842s.827.378.827.842a.836.836 0 0 1-.827.842m0-1.123a.28.28 0 0 0-.276.281c0 .155.123.28.276.28a.28.28 0 0 0 .275-.28.28.28 0 0 0-.275-.28M7.724 13.474a.836.836 0 0 1-.828-.842c0-.464.372-.842.828-.842s.828.378.828.842a.836.836 0 0 1-.828.842m0-1.123a.28.28 0 0 0-.276.281c0 .155.124.28.276.28a.28.28 0 0 0 .276-.28.28.28 0 0 0-.276-.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M11.035 18.244v.28c0 .155-.124.281-.276.281a.28.28 0 0 1-.276-.28v-.281zm.551-.561H9.931v.842c0 .464.371.842.828.842a.836.836 0 0 0 .827-.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA0D2",
    d: "M10.759 16.561a.557.557 0 0 1-.552-.561v-.562c0-.31.247-.561.552-.561.304 0 .551.251.551.561V16c0 .31-.247.561-.551.561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5064AA",
    d: "M9.379 17.962a.835.835 0 0 0 .828-.842.835.835 0 0 0-.828-.842.835.835 0 0 0-.828.842c0 .465.371.842.828.842"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB446",
    d: "M9.655 10.948h-.551v1.684h.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "m7.724 13.755-.551-.562.323-.329a2.64 2.64 0 0 1 1.883-.794c.707 0 1.385.286 1.884.794l.323.33-.551.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD250",
    d: "M9.379 13.473a.28.28 0 0 0 .276-.281.28.28 0 0 0-.276-.28.28.28 0 0 0-.276.28c0 .155.123.28.276.28M8.275 13.474a.28.28 0 0 0 .276-.281.28.28 0 0 0-.276-.28.28.28 0 0 0-.276.28c0 .155.124.28.276.28M10.483 13.473a.28.28 0 0 0 .275-.281.28.28 0 0 0-.275-.28.28.28 0 0 0-.276.28c0 .155.123.28.275.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8414B",
    d: "M7.172 15.999H4.413v.561h2.76zM4.415 18.244l1.655-.561v-.562l-1.655.562z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "country-flag-spain_svgrIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCountryFlagSpainsvgrIcon);
export default ForwardRef;